export const NotFoundPage = () => {
    return (
        <div className="main-content">
            <p>Not found</p>
        </div>
    );
}